import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import axios from 'axios';
import Cookies from 'js-cookie';


export default function Graph3() {
  const [state, setState] = useState({
    series: [],
    options: {
      chart: {
        type: 'bar',
        height: 350
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
        }
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val;
        },
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ['#304758'],
        },
      },
      xaxis: {
        categories: []
      }
    }
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token =Cookies.get('token')

        const response = await axios.get('https://hotfix-back-hris.talentfort.live/graph3',{
          headers: {
             Authorization: `Bearer ${token}`,
          },
        });
        const data = response.data;

        const categories = data.map((item) => item.employeeActive);
        const series = data.map((item) => item.employeeCount);

        setState((prevState) => ({
          ...prevState,
          series: [ {
            name: 'Employee Count',
            data: series,
          },],
          options: {
            ...prevState.options,
            xaxis: {
              categories: categories,
            },
          },
        }));
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  return (
    <div id="chart">
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="bar"
        height={350}
      />
    </div>
  );
}
